export const HUBSPOT = 0;
export const FLOW = 1;
export const CAPTURED = 2;
export const FACEBOOK_LEAD_AD = 3;
export const BLOG_COMMENT = 4;
export const MEETING = 5;
export const FEEDBACK = 6;
export const TICKET_FORM = 7;
export const DOCUMENT = 8;
export const VIDEO_FORM = 9;